import { createAction } from '../utils/state';


export const actionTypes = {
    CLEAR_ROOT: 'CLEAR_ROOT',
};

export const actions = {
    clearRoot: createAction(actionTypes.CLEAR_ROOT),
};
